import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { marketReportStatus, recentListingStatus } from '../_config';
import searchBar from '../../md-search-bar/_store';
import { mergeModules } from '@/store/helpers';
// const ModuleName = 'snapshot';
// 初始的state数据
function initState() {
    return {
        // isSearchInit: false, // md-search 是否已完成初始化话
        listingStatus: [], // listing status 列表
        listing: [], // listing 房源列表
        marketReport: {}, // 服务端获取的 market report 数据
        // market report模块处于的状态
        fetchMarketReportStatus: marketReportStatus.coming,
        // 房源recent listing模块处于的状态
        fetchListingStatus: recentListingStatus.coming,
        currentListingStatus: '', // 当前选中的listingStatus
        currentListingStatusName: '', // 当前选中的listingStatus的name值，用于展示
        // 分页参数
        totalPage: 0,
        pageSize: 5,
        pageNum: 1,
        // more btn
        moreBtnTitle: 'Request More Market Insights',
        moreBtnStyle: {},
        // custom recent listing title
        customListingTitle: 'Recent Listings',
        showListingPrice: true, // 是否需要显示listing price
        showSoldPrice: true, // 是否需要显示sold listing price
        searchParams: {}
    };
}
export const snapshotSearchStore = {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
export default mergeModules(snapshotSearchStore, searchBar);